import { Container, filters, ticker } from 'pixi.js';
import { PixelateFilter } from '@pixi/filter-pixelate';
import TweenLite from 'gsap/TweenLite';

import config from './config';

class TextFx extends Container {
  constructor(txt) {
    super();
    this.txt = txt;
    this.ticker = new ticker.Ticker();
    this.ticker.stop();
    this.state = {
      noise: 0,
      blurX: 0,
      blurY: 0,
      pixelSize: 1,
    }
    this.noise = new filters.NoiseFilter();
    this.blurred = new filters.BlurFilter();
    this.pixel = new PixelateFilter();

    this.filters = [this.blurred];
    this.ticker.add(this.animate);
    this.addChild(this.txt);
  }

  animate = () => {
    this.noise.noise = Math.random() * this.state.noise;
    this.blurred.blurX = Math.random() * this.state.blurX;
    this.blurred.blurY = Math.random() * this.state.blurY;
    this.pixel.size = Math.random() * this.state.pixelSize + 1;
  }

  animateIn() {
    this.ticker.start();
    TweenLite.fromTo(this.state,
      config.text.duration, {
        noise: config.text.noise,
        blurX: config.text.blurX,
        blurY: config.text.blurY,
        pixelSize: config.text.pixelSize
      }, {
        noise: 0,
        blurX: 0,
        blurY: 0,
        pixelSize: 0,
        onComplete: () => {
          this.filters = null;
          this.ticker.stop()
        }
      })

    TweenLite.to(this, 1, { alpha: 1 })
  }

  animateOut(fn) {
    this.ticker.start();
    TweenLite.fromTo(this.state,
      config.text.duration,
      {
        noise: 0,
        blurX: 0,
        blurY: 0,
        pixelSize: 0,
      },
      {
        noise: config.text.noise,
        blurX: config.text.blurX,
        blurY: config.text.blurY,
        pixelSize: config.text.pixelSize,
      })

    TweenLite.to(this, 1, { alpha: 0,
      delay: 2,
      onComplete: () => {
        this.ticker.stop()
        this.filters = null;
        if (fn) fn();
      }
    })
  }

  _destroy() {
    TweenLite.killTweensOf(this);
    TweenLite.killTweensOf(this.state);
  }
}

export default TextFx;



// WEBPACK FOOTER //
// ./app/frontend/components/animations/lighting/index.js